import {getSelector, selectors, getAmountWithCurrency, getDeliveryAfterDiscount} from "../global";

const updateTotals = (response) => {
	// Athan, total and tax are not following DXP
	// todo: min. let's delete above comment, later
	getSelector(selectors.total).html(getAmountWithCurrency(response.total))
	getSelector(selectors.tax).html(getAmountWithCurrency(response.tax))
	getSelector(selectors.discount).html(getAmountWithCurrency(response.discounts.products.totals.total));``
	getSelector(selectors.delivery).html(getDeliveryAfterDiscount(response.zbs.selected_rate, response.discounts, response.taxTotals.shipping))
}

export default updateTotals
